import { reactive, ref, readonly } from "vue";

const state = reactive({
    originalImage: reactive({
        filename: "",
        position: "",
        backgroundColor: "",
        size: reactive({
            width: 1024,
            height: 600,
        }),
    }),
    currentImage: reactive({
        filename: "",
        data: null,
        position: "",
        backgroundColor: "",
        size: reactive({
            width: 1024,
            height: 600,
        }),
    }),
    uniqueId: "",
    csrf: "",
    rangeSize: reactive({
        width: 1024,
        height: 600,
    }),
    renderingRegionSize: reactive({
        width: 1024,
        height: 600,
    }),
    uploadedFile: reactive(),
    uploadedImage: reactive(),
    ratio: 1.0,
    windowSize: reactive({
        width: window.innerWidth,
        height: window.innerHeight
    })
});

// getter
const currentImageFullUrl = () => {
    return "/storage/" + state.uniqueId + "/" + state.currentImage.filename;
};

// mutation
const clearAll = () => {
    state.uploadedImage = null;
    state.uploadedFile = null;
    state.originalImage.filename = null;
    state.originalImage.position = "top 0px left 0px";
    state.currentImage.filename = null;
    state.currentImage.position = "top 0px left 0px";
    state.currentImage.backgroundColor = "#58BE89";
};
const setUniqueId = (uniqueId) => {
    state.uniqueId = uniqueId;
};
const setCsrfToken = (token) => {
    state.csrf = token;
};
const setSelectedImage = (image) => {
    state.uploadedImage = image;
};
const setSelectedFile = (file) => {
    state.uploadedFile = file;
};
const setBackgroundColor = (color) => {
    state.currentImage.backgroundColor = color;
};
const setOriginal = (filename, position) => {
    state.originalImage.filename = filename;
    state.originalImage.position = position;
};
const setCurrent = (filename, position) => {
    state.currentImage.filename = filename;
    state.currentImage.position = position;
};
const setPosition = (position) => {
    state.originalImage.position = position;
    state.currentImage.position = position;
};
const currentImage = () => {
    return state.currentImage;
};
const uploadedFile = () => {
    return state.uploadedFile;
};
const uploadedImage = () => {
    return state.uploadedImage;
};
const setImageSize = (imageWidth, imageHeight) => {
    state.currentImage.size.width = imageWidth;
    state.currentImage.size.height = imageHeight;

    state.rangeSize.width = imageWidth - state.renderingRegionSize.width;
    state.rangeSize.height = imageHeight - state.renderingRegionSize.height;
};
const setRenderingRegionSize = (width, height) => {
    state.renderingRegionSize.width = width;
    state.renderingRegionSize.height = height;
}
const setRatio = () => {
    state.ratio = (state.windowSize.width > 750 ? 1024 : state.windowSize.width) / 1024.0;
};
const clearSelectedFile = () => {
    state.uploadedFile = null;
    state.uploadedImage = null;
};
const calcAverageColor = (image) => {
    const canvas = document.createElement("canvas");
    const style = canvas.style;

    style.width = image.width + "px";
    style.height = image.height + "px";

    const ctx = canvas.getContext("2d");
    ctx.drawImage(image, 0, 0);
    const data = ctx.getImageData(0, 0, canvas.width, canvas.height);

    let tmp = 0;
    let R = 0;
    let G = 0;
    let B = 0;
    let A = 0;
    let num = data.height * data.width;

    for (var i = 0; i < data.height; i++) {
        for (var j = 0; j < data.width; j++) {
            tmp = i * (data.width * 4) + j * 4;
            R += data.data[tmp + 0];
            G += data.data[tmp + 1];
            B += data.data[tmp + 2];
            A += data.data[tmp + 3];
        }
    }
    return rgb2hex([
        Math.round(R / num),
        Math.round(G / num),
        Math.round(B / num),
    ]);
};

const getArrangedPosition = (position) => {
    // position  を整形
    let tmpY = position.match(/top\ (-?[0-9]+)px/);
    let tmpX = position.match(/left\ (-?[0-9]+)px/);

    return (
        "top " +
        (tmpY != null && state.ratio != 0
            ? Math.floor(tmpY[1] / state.ratio)
            : 0) +
        "px " +
        "left " +
        (tmpX != null && state.ratio != 0
            ? Math.floor(tmpX[1] / state.ratio)
            : 0) +
        "px"
    );
};

const rollbackToOriginal = () => {
    copyOriginalToCurrent();
    // size
    setImageSize(
        state.originalImage.size.width,
        state.originalImage.size.height
    );
    state.uploadedFile = null;
    state.uploadedImage = null;
};

const setCurrentPosition = (position) => {
    state.currentImage.position = position;
};

// action
const uploadImage = () => {
    let params = new FormData();

    if (state.uploadedFile) {
        params.append("image", state.uploadedFile);
    }
    params.append(
        "image_position",
        getArrangedPosition(state.currentImage.position)
    );

    return axios.post("/blogs/" + state.uniqueId + "/image", params, {
        headers: {
            "X-CSRF-TOKEN": state.csrf,
            "Content-Type": "application/x-www-form-urlencoded",
            "X-HTTP-Method-Override": "PUT",
        },
    });
};
const updatePosition = (position) => {
    return axios.post("/blogs/" + state.uniqueId + "/image", params, {
        headers: {
            "X-CSRF-TOKEN": state.csrf,
            "Content-Type": "application/x-www-form-urlencoded",
            "X-HTTP-Method-Override": "PUT",
        },
    });
};
const deleteImage = () => {
    return axios.delete("/blogs/" + state.uniqueId + "/image");
};

const setOriginalImageSize = (width, height) => {
    state.originalImage.size.width = width;
    state.originalImage.size.height = height;
};
const setOriginalBackgroundColor = (color) => {
    state.originalImage.backgroundColor = color;
};
const copyOriginalToCurrent = () => {
    state.currentImage.size.width = state.originalImage.size.width;
    state.currentImage.size.height = state.originalImage.size.height;
    state.currentImage.filename = state.originalImage.filename;
    state.currentImage.position = state.originalImage.position;
    state.currentImage.backgroundColor = state.originalImage.backgroundColor;
};
const copyCurrentToOriginal = () => {
    state.originalImage.size.width = state.currentImage.size.width;
    state.originalImage.size.height = state.currentImage.size.height;
    state.originalImage.filename = state.currentImage.filename;
    state.originalImage.position = state.currentImage.position;
    state.originalImage.backgroundColor = state.currentImage.backgroundColor;
};
const setWindowSize = () => {
    state.windowSize.width = window.innerWidth;
    state.windowSize.height = window.innerHeight;
}
export default {
    state,
    setRatio,
    setBackgroundColor,
    setImageSize,
    setSelectedFile,
    setSelectedImage,
    setUniqueId,
    setOriginal,
    setCurrent,
    setPosition,
    setCsrfToken,
    clearSelectedFile,
    uploadImage,
    deleteImage,
    currentImageFullUrl,
    rollbackToOriginal,
    setCurrentPosition,
    clearAll,
    currentImage,
    uploadedFile,
    uploadedImage,
    setOriginalImageSize,
    setOriginalBackgroundColor,
    copyOriginalToCurrent,
    copyCurrentToOriginal,
    setRenderingRegionSize,
    setWindowSize
};
